import { render } from "./ShelfTemplateProduct.vue?vue&type=template&id=ba93787c&scoped=true"
import script from "./ShelfTemplateProduct.vue?vue&type=script&lang=js"
export * from "./ShelfTemplateProduct.vue?vue&type=script&lang=js"

import "@/assets/scss/_shelf.scss?vue&type=style&index=0&id=ba93787c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba93787c"]])

export default __exports__